export default "__VITE_ASSET__Dcsl8_GM__"